import { DisplayProcessingLogics, PoolDeviceCriticalDesiredActual } from "../Types";
import { IOnoffable, PoolDeviceInterface } from "../Interfaces";
import Locale from "../../utils/Locale";
import { DeviceConfig, DeviceTypes } from "../../config/documents/HardwareConfig";
import PoolDeviceOnOffable from "./base-onoffable";
import { ValueAndUnit } from "../../types";
import { convertConfigHvac } from "../common-hvac";

export enum criticalFieldIdentifiers {
    OnOff = "OnOff",
}

export default class PoolDeviceHeater extends PoolDeviceOnOffable implements PoolDeviceInterface, IOnoffable {
    static CanBeAddedToflow = true;
    static DeviceType = DeviceTypes.HEATER;
    static Icon = "flame";
    OnOffIdentifier = criticalFieldIdentifiers.OnOff;
    static PickerTitle = Locale.gettext("Heater");

    getDisplayNameTranslated(displayName:string) {
        switch (displayName) {
        case "Status message": return Locale.gettext("Status message");
        case "Status": return Locale.gettext("Status");
        case "Firmware Version": return Locale.gettext("Firmware Version");
        case "Flue Temperature": return Locale.gettext("Flue Temperature");
        case "Flue Temp": return Locale.gettext("Flue Temp");
        case "Inlet Temperature": return Locale.gettext("Inlet Temperature");
        case "Inlet Temp": return Locale.gettext("Inlet Temp");
        case "Outlet Temperature": return Locale.gettext("Outlet Temperature");
        case "Outlet Temp": return Locale.gettext("Outlet Temp");
        case "Lifetime Hours": return Locale.gettext("Lifetime Hours");
        case "Lifetime Heat Cycles": return Locale.gettext("Lifetime Heat Cycles");
        case "Flame strength": return Locale.gettext("Flame strength");
        case "Power Cycle Count": return Locale.gettext("Power Cycle Count");
        case "Power Supply Voltage": return Locale.gettext("Power Supply Voltage");
        case "Unit Serial": return Locale.gettext("Unit Serial");
        default: return super.getDisplayNameTranslated(displayName);
        }
    }

    formatDeviceStatusCustom(DisplayProcessingLogic: DisplayProcessingLogics, value: any): ValueAndUnit {
        switch(DisplayProcessingLogic) {
        case DisplayProcessingLogics.HEATER_FRIENDLY_STATE:
            switch (value) {
            case "INITIALIZATION": return { value: Locale.gettext("Initialization") };
            case "NO_DEMAND": return { value: Locale.gettext("No demand") };
            case "PRE_PURGE": return { value: Locale.gettext("Pre purge") };
            case "SPARK": return { value: Locale.gettext("Spark") };
            case "HEATING": return { value: Locale.gettext("Heating") };
            case "POST_PURGE": return { value: Locale.gettext("Post purge") };
            case "VERIFYING_WATER": return { value: Locale.gettext("Verify water") };
            case "FAULT": return { value: Locale.gettext("Fault") };
            case "UNKNOWN": return { value: Locale.gettext("Unknown") };
            default: return { value };
            }
        default: return super.formatDeviceStatusCustom(DisplayProcessingLogic, value);
        }
    }

    getConfig(AutoFilterVersion?: number): DeviceConfig {
        return convertConfigHvac(this.deviceConfig, AutoFilterVersion);
    }

    getCriticalFields(): PoolDeviceCriticalDesiredActual[] {
        let order = 0;
        const fields = [];
    
        {
            const DisplayName = Locale.gettext("Power");
            const common = {
                DisplayName, DisplayNameShort: DisplayName,
                DisplayOrder: ++order,
                DisplayProcessingLogic: DisplayProcessingLogics.ONOFF,
                DisplayProcessingLogicUnitAsDisplayName: false,
                DisplayDiffTimeout: 120,
            };
            fields.push({
                Identifier: criticalFieldIdentifiers.OnOff,
                ActualProperty: Object.assign({ Name: PoolsideDaemonDeviceStateNames.ActualPowerState }, common),
                DesiredProperty: Object.assign({ Name: PoolsideDaemonDeviceStateNames.PowerState }, common)
            });
        }
    
        return fields;
    }
}

export enum PoolsideDaemonDeviceStateNames {
    ActualPowerState = "ActualPowerState",
    PowerState = "PowerState",
}
